import { render, staticRenderFns } from "./new-shows-existing.vue?vue&type=template&id=3fc85836&scoped=true&"
import script from "./new-shows-existing.vue?vue&type=script&lang=js&"
export * from "./new-shows-existing.vue?vue&type=script&lang=js&"
import style0 from "./new-shows-existing.vue?vue&type=style&index=0&id=3fc85836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc85836",
  null
  
)

export default component.exports